import { Link } from 'react-router-dom';
import { site, nav } from '@/data/site';
import Stars from '@/components/base/Stars';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-primary-950 pt-16 pb-8 overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-500/60 to-transparent" />
      <div className="absolute inset-0 opacity-[0.06] bg-[radial-gradient(circle_at_15%_10%,oklch(var(--accent-500))_0,transparent_40%),radial-gradient(circle_at_85%_80%,oklch(var(--secondary-400))_0,transparent_45%)]" />

      <div className="relative w-full px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <span className="inline-flex items-center justify-center rounded-md bg-white px-2 py-1.5">
              <img
                src={site.logo}
                alt="Arnold Gartenpflege – Logo"
                title="Arnold Gartenpflege"
                className="h-9 w-auto object-contain"
              />
            </span>
            <p className="mt-5 font-body text-sm leading-relaxed text-background-100/70">
              Ihr Gartenpflege-Fachbetrieb aus Röttenbach bei Erlangen. Gartenpflege, Baumpflege &amp;
              Winterdienst für Privat und Gewerbe.
            </p>
            <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-background-50/15 bg-background-50/[0.06] px-3.5 py-2">
              <Stars size="text-sm" />
              <span className="font-label text-sm font-semibold text-background-50">
                {site.rating} bei Google
              </span>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-label text-sm font-semibold uppercase tracking-[0.18em] text-background-50">
              Navigation
            </h3>
            <ul className="mt-5 space-y-3">
              {nav.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="font-body text-sm text-background-100/75 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-label text-sm font-semibold uppercase tracking-[0.18em] text-background-50">
              Kontakt
            </h3>
            <ul className="mt-5 space-y-3 font-body text-sm text-background-100/75">
              <li>
                <a href={site.phoneHref} className="hover:text-accent-400 transition-colors cursor-pointer">
                  {site.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={site.emailHref}
                  className="hover:text-accent-400 transition-colors cursor-pointer break-all"
                >
                  {site.email}
                </a>
              </li>
              <li>
                {site.street}
                <br />
                {site.city}
              </li>
              <li>
                <a
                  href={site.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line" />
                  Instagram
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="font-label text-sm font-semibold uppercase tracking-[0.18em] text-background-50">
              Öffnungszeiten
            </h3>
            <ul className="mt-5 space-y-3 font-body text-sm">
              {site.hours.map((h) => (
                <li key={h.day} className="flex flex-col">
                  <span className="text-background-50">{h.day}</span>
                  <span className="text-background-100/70">{h.time}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-background-50/12 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="font-body text-xs text-background-100/55">
            © {year} {site.name} · Inhaber {site.owner}. Alle Rechte vorbehalten.
          </p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <Link
              to="/impressum"
              className="font-body text-xs text-background-100/70 hover:text-accent-400 transition-colors cursor-pointer"
            >
              Impressum
            </Link>
            <Link
              to="/datenschutz"
              className="font-body text-xs text-background-100/70 hover:text-accent-400 transition-colors cursor-pointer"
            >
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}